import { createContext, useContext } from 'react';

// Create the context with 'null' as the default value.
// Consumers will check for null or rely on the Provider to ensure a value is set.
export const ConfigContext = createContext(null);

// Custom hook for easy consumption of the config context
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    // This error means you are trying to use the context
    // outside of a <ConfigProvider> component.
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  // We explicitly allow null here, as the provider handles the loading state.
  // Components consuming the context might need to check for null if they render
  // before the config is fully loaded (though our provider prevents this by default).
  return context;
};